// Unpublished Work © 2026 Deere & Company.

import {
    SET_DIGITAL_USER_ACCOUNT_DETAILS,
    SET_DIGITAL_USER_ACCOUNT_DETAILS_TO_DEFAULT,
    SHOW_DIGITAL_USER_ACCOUNT_ERROR
} from '../../action-list';
import {DigitalUserAccountDetails} from '../../state/struct/profile/digital-user-account-details';

const setDigitalUserAccountDetails = (state, action) =>
    DigitalUserAccountDetails.update(state, {
        $merge: {
            ...action.digitalUserAccountDetails,
            isDigitalUserAccountLoading: false,
            errorMessage: ''
        }
    });

const showDigitalUserAccountError = (state, action) =>
    DigitalUserAccountDetails.update(state, {
        $merge: {
            isDigitalUserAccountLoading: false,
            errorMessage: action.errorMessage || ''
        }
    });

const setDigitalUserAccountDetailsToDefault = () => DigitalUserAccountDetails({});

export function digitalUserAccountDetails(state = new DigitalUserAccountDetails({}), action = {}) {
    const actionHandlers = {
        [SET_DIGITAL_USER_ACCOUNT_DETAILS]: setDigitalUserAccountDetails,
        [SHOW_DIGITAL_USER_ACCOUNT_ERROR]: showDigitalUserAccountError,
        [SET_DIGITAL_USER_ACCOUNT_DETAILS_TO_DEFAULT]: setDigitalUserAccountDetailsToDefault
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
